import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Chat.css"
import { faAngleLeft, faPaperclip, faPaperPlane, faXmark } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import Message from "./Message";

function Chat({ chatId, chatName, messages, loading, loadingMessage, hide, sendHandler, log, dataReset }) {
    /*
    messages:[{
      id --ИД сообщения
    , name --Имя пользователя
    , text --Текст сообщение
    , avatar
    , myMessage --Мое сообщение
    , date - Дата сообщения
    , files - файлы
    }]

    files :[{
         idFile - ИД файла
        ,name - Название файла
        ,idType - Тип файла 0	Не определено
                            1	Видео
                            2	Фото
                            3	Музыка
                            4	Excel
                            5	Word
                            6	Pdf
                            7	Архив
    }]
    */

    /*https://habr.com/ru/articles/498576/*/
    const stateSize = useSelector((state) => state.size);

    const refFooter = useRef(null);
    const refFile = useRef(null);
    const refChatFile = useRef(null);
    const [heightFooter, setHeightFooter] = useState(50);
    const [heightFile, setHeightFile] = useState(0);
    const [text, setText] = useState('');

    // const [fileModal, setFileModal] = useState(false);
    const [files, setFiles] = useState([]);
    /****************************START РАЗМЕР FOOTER***************************/
    useEffect(() => {
        setHeightFooter(refFooter.current.clientHeight);
    }, []);

    useEffect(() => {
        setHeightFooter(refFooter.current.clientHeight);
    }, [text]);
    useEffect(() => {
        setHeightFile(refChatFile.current.clientHeight);
    }, [files]);

    useEffect(() => {
        if (dataReset === true) {
            setText('');
            setFiles([]);
        }
    }, [dataReset]);
    /*****************************END РАЗМЕР FOOTER****************************/
    function sendMessageHandler() {
        if (!loadingMessage) {
            //Проверка на пробелы
            if (text.trim().length !== 0 || files.length > 0) {
                sendHandler(chatId, text, files);
                refFooter.current.innerText = '';
                /*setText('');
                setFiles([]);*/
            }
        }
    }
    const sendMessageHandlerKeyPress = (event) => {
        if (!loadingMessage) {
            if (event.key === 'Enter') {
                event.preventDefault();

                //Проверка на пробелы
                if (text.trim().length !== 0 || files.length > 0) {
                    sendHandler(chatId, text);
                    refFooter.current.innerText = '';
                    /* setText('');
                     setFiles([]);*/
                }
            }
        }
    };

    function changeFilesHandler(e) {

        const files_ = Array.from(e.target.files);
        setFiles(files_);
    }
    function removeFilesHandler(name) {
        var files_ = [];
        files.map(f => {
            if (f.name !== name) {
                files_.push(f)
            }
        })
        setFiles(files_);
    }



    return (
        <>
            <div className="chat_block" >
                <div className="chat_header">
                    <div className="back">
                        <button className="tabbar-button" onClick={hide}>
                            <FontAwesomeIcon icon={faAngleLeft} className="mr-5 opacity-50" /> Назад
                        </button>
                    </div>
                    <div className="name">{chatName}</div>
                </div>
                <div className="chat_body" style={{ height: stateSize.windowHeight - 150 - heightFooter - heightFile }}>
                    {loading === true && (<div className="loader_01"></div>)}
                    <div className="message_block">
                        {messages.map(item => (
                            <Message key={item.id} message={item} />
                        ))}
                    </div>
                </div>
                <div className="chat_files" ref={refChatFile}>
                    {files.map(f => (
                        <div key={f.name} className="file" >
                            {f.name}
                            <FontAwesomeIcon icon={faXmark} className="mr-5 ml-5 opacity-50 text-danger remove" onClick={() => removeFilesHandler(f.name)} />
                        </div>
                    ))}
                </div>

                {log !== null && <div className="chat_error">{log}</div>}

                <div className={!loadingMessage ? "chat_footer" : "chat_footer disabled_footer"}>
                    <div className="paper_clip">
                        <FontAwesomeIcon icon={faPaperclip} className="mr-5 opacity-50 fs-2" onClick={() => refFile.current.click()} />
                        <input type="file" multiple ref={refFile} style={{ display: "none" }} onChange={(e) => changeFilesHandler(e)} />
                    </div>
                    <div className="input_div"
                        ref={refFooter}
                        contentEditable={"plaintext-only"}
                        onInput={(e) => setText(e.target.innerText)}
                        onKeyDown={(e) => sendMessageHandlerKeyPress(e)}
                    >
                    </div>
                    <div className="paper_clip">
                        <FontAwesomeIcon icon={faPaperPlane} className="mr-5 opacity-50 fs-2" onClick={() => sendMessageHandler()} />
                    </div>
                </div>

            </div>
        </>
    )
}

export default Chat;